export const BACKEND_URL = 'https://in5-api-preprod.ken42.com/'; //"http://localhost:4003/";

export const TABLET_BREAKPOINT = 'tablet';

export const KEY_CONFIG_URL = 'https://config-api.ken42.com/v1/configs/url';  

export const KEY_AZURE_TOKEN = 'azure_token';

export const REFRESH_URL = 'https://in5-api-preprod.ken42.com/app/refreshToken';

export const KEY_ACCESS_TOKEN = 'access_token';
export const KEY_REFRESH_TOKEN = 'refresh_token';

export const PUBLIC_BACKGROUND_IMAGE_URL = 'https://infivestoragedev.blob.core.windows.net/infive/In5-PublicBackgroundImage.jpg'
// 'https://flamestorageken42.blob.core.windows.net/flame-storage-ken42/In5-PublicBackgroundImage.jpg';

export const LOGO = 'https://infivestoragedev.blob.core.windows.net/infive/in5-logo-1.png';
// 'https://flamestorageken42.blob.core.windows.net/flame-storage-ken42/in5-logo.png';

export const REGEX = {
  NAME: /^[a-zA-Z ]*$/,
  MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  PINCODE: /^[0-9]{4,7}$/,
  NUMBER: /^[0-9]/,
  YEAR: /^[0-9]{4,4}$/,
  ONLYNUMBER: /^[0-9]*$/,
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  DIGIT: /\d/,
  SPECIAL: /[$&+,:;=?@#|'<>.^*()%!-]/,
  NUMBERWITHDECIMAL: /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/,
  DIGITS_ONLY_UPTO_100: /^\-?(([0-9]\d?|0\d{1,2})((\.)\d{0,2})?|100((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_10: /^\-?((0\d|\d)?((\.)\d{0,2})?|10((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_4: /^\-?((0[0-3]|[0-3])?((\.)\d{0,2})?|(4|04)((\.)0{1,2})?)$/,
  PERCENTAGE: /^100$/,
  CGPA: /^10$/,
  GRADE: /^[a-fA-FOoPp]$/,
  MIXED: /^[a-zA-Z0-9-./, ]*$/,
  GST: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  PARENT_DOC: /^aadhaarParent/,
  PHONE_NUMBER: /^[0-9]*$/,
  PASSWORD: '(?=.*d)(?=.*[a-z])(?=.*[A-Z]).{8,}',
  AADHAAR: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  WEBSITE: /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
  EMAIL: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
  CONTAINNUMBERS: /.*\d.*/,
  CONTAINSYMBOLS: /.*[!~`@#$%^&*()_+\-=<,.>\/?].*/,
  CONTAINUPPERCASE: /.*[A-Z].*/,
};

// Prod
export const  GOOLE_CLIENT_ID = '1077373127871-td2ok8jiql2nihf80veq1qfbe3so4phr.apps.googleusercontent.com';

// Local
// export const GOOLE_CLIENT_ID = '480030465957-pnnlncss6clu5hkc890tvo2jois741r6.apps.googleusercontent.com';

export const CURRENCYCODE: any = {
  AUD: '$',
  BDT: '৳',
  BTC: '₿',
  CAD: '$',
  CNY: '¥',
  CRC: '₡',
  ETH: 'Ξ',
  EUR: '€',
  GBP: '£',
  GEL: '₾',
  HKD: '$',
  ILS: '₪',
  INR: '₹',
  JPY: '¥',
  KRW: '₩',
  LTC: 'Ł',
  MXN: '$',
  NGN: '₦',
  NZD: '$',
  PHP: '₱',
  PLN: 'zł',
  PYG: '₲',
  RUB: '₽',
  SGD: '$',
  THB: '฿',
  TRY: '₺',
  UAH: '₴',
  USD: '$',
  VND: '₫',
  XMR: 'ɱ',
};